import React, { useState, useEffect } from "react";
import { adminConfig } from "../../api/configApi";

function AdminGuard() {
  const [showInput, setShowInput] = useState(false);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.key === "k") {
        event.preventDefault();
        setShowInput(true); // Muestra el modal
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const closeModal = () => {
    setInputValue('');
    setShowInput(false);
  };

  const handleEnterPress = async (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      const value = {
        value: inputValue,
      };
      await adminConfig(value);
      setInputValue('');
      window.location.reload();
      setShowInput(false); // Oculta el input al presionar Enter, si lo deseas
    }
  };

  return (
    <div>
      {showInput && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            <input
              type="password"
              value={inputValue}
              onChange={handleInputChange}
              onKeyDown={handleEnterPress}
              autoFocus
              style={styles.input}
            />
            <button
              type="button"
              className="btn btn-icon btn-danger"
              onClick={closeModal}
            >
              Cerrar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)", // Fondo semi-transparente
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000, // Asegura que se superponga sobre otros elementos
  },
  modal: {
    backgroundColor: "white",
    padding: "20px",
    borderRadius: "8px",
    width: "300px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    textAlign: "center",
    position: "relative",
  },
  input: {
    width: "100%",
    padding: "10px",
    marginBottom: "10px",
    fontSize: "16px",
    borderRadius: "4px",
    border: "1px solid #ccc",
  },
};

export default AdminGuard;
